import React from "react";
import { Apple, BoxArrowUpRight } from "react-bootstrap-icons";
import "./appStoreGuidance.css";

const APPLE_SUBSCRIPTIONS_URL = "https://apps.apple.com/account/subscriptions";

/**
 * Shared App Store guidance block.
 *
 * Rendered inside ManageSubscriptionModal (subscription management) and
 * UpgradePlanModal (checkout gate) so the message stays identical wherever
 * an App-Store-billed user lands.
 */
const AppStoreGuidance = () => (
  <div className="app-store-guidance">
    <div className="app-store-guidance-icon">
      <Apple />
    </div>
    <p className="app-store-guidance-text">
      Your subscription is billed through the Apple App&nbsp;Store.
    </p>
    <p className="app-store-guidance-text">
      To manage or cancel it, open <strong>Settings &gt; Subscriptions</strong>{" "}
      on your iOS device.
    </p>
    <a
      className="app-store-guidance-link"
      href={APPLE_SUBSCRIPTIONS_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      Or manage it in your browser{" "}
      <span className="visually-hidden">(opens in a new tab)</span>
      <BoxArrowUpRight aria-hidden="true" />
    </a>
  </div>
);

export default AppStoreGuidance;
